import React, { useState, useEffect } from 'react';
import logo1 from './items/logo1 2.png';
import logo2 from './items/logo2 2.png';
import parisImg from './items/paris.png';
import usaImg from './items/usa.png';
import ukImg from './items/uk.png';
import canadaImg from './items/canada.png';
import studentImg from './items/student.png';
import businessImg from './items/business.png';

const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetler',
      about: 'Hakkımızda',
      contact: 'İletişim',
    },
    hero: {
      title_start: 'Dünyanın Kapılarını',
      title_end: 'ile Aralayın',
      subtitle: 'Profesyonel vize danışmanlığı ile seyahatlerinizi planlayın. Sınırları aşmanız için yanınızdayız.',
      btn_contact: 'Bize Ulaşın',
      btn_services: 'Hizmetlerimiz',
    },
    services: {
      title: 'Hizmet Alanlarımız',
      subtitle: 'Vize Çözümlerimiz',
      items: [
        { title: 'Schengen Vizesi', desc: 'Avrupa seyahatleriniz için profesyonel danışmanlık.' },
        { title: 'Amerika Vizesi', desc: 'ABD turist, öğrenci ve çalışma vizelerinde uzman destek.' },
        { title: 'İngiltere Vizesi', desc: 'Birleşik Krallık vize süreçlerinde titiz hazırlık.' },
        { title: 'Kanada Vizesi', desc: 'Kanada seyahat ve göçmenlik başvuruları.' },
        { title: 'Öğrenci Vizeleri', desc: 'Yurtdışı eğitim hayalleriniz için vize çözümleri.' },
        { title: 'Ticari Vizeler', desc: 'İş seyahatleriniz için hızlı ve güvenilir süreç.' },
      ]
    },
    about: {
      title: 'Hakkımızda',
      subtitle: 'Neden Globinkey?',
      text: 'Globinkey olarak, vize başvuru süreçlerinin karmaşıklığını en aza indirerek, müşterilerimize stressiz ve güvenilir bir deneyim sunuyoruz. Uzman ekibimiz, güncel prosedürlere hakimiyeti ve detaycı yaklaşımıyla başvurularınızın olumlu sonuçlanması için titizlikle çalışır.',
      bullets: [
        'Yüksek Başarı Oranı',
        'Kişiye Özel Danışmanlık',
        '7/24 Destek',
        'Şeffaf Süreç Yönetimi'
      ]
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Bizimle İletişime Geçin',
      info_title: 'İletişim Bilgileri',
      address_label: 'Adres',
      address_val: 'İstanbul, Türkiye',
      phone_label: 'Telefon',
      email_label: 'E-posta',
      form: {
        name: 'Ad Soyad',
        name_ph: 'Adınız Soyadınız',
        email: 'E-posta',
        email_ph: 'ornek@email.com',
        message: 'Mesajınız',
        message_ph: 'Size nasıl yardımcı olabiliriz?',
        submit: 'GÖNDER'
      }
    },
    footer: {
      rights: '© 2024 Tüm hakları saklıdır.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About Us',
      contact: 'Contact',
    },
    hero: {
      title_start: 'Unlock the World with',
      title_end: '',
      subtitle: 'Plan your travels with professional visa consultancy. We are here to help you cross borders.',
      btn_contact: 'Contact Us',
      btn_services: 'Our Services',
    },
    services: {
      title: 'Our Services',
      subtitle: 'Visa Solutions',
      items: [
        { title: 'Schengen Visa', desc: 'Professional consultancy for your European travels.' },
        { title: 'USA Visa', desc: 'Expert support for US tourist, student, and work visas.' },
        { title: 'UK Visa', desc: 'Meticulous preparation for United Kingdom visa processes.' },
        { title: 'Canada Visa', desc: 'Canada travel and immigration applications.' },
        { title: 'Student Visas', desc: 'Visa solutions for your study abroad dreams.' },
        { title: 'Business Visas', desc: 'Fast and reliable process for your business trips.' },
      ]
    },
    about: {
      title: 'About Us',
      subtitle: 'Why Globinkey?',
      text: 'At Globinkey, we minimize the complexity of visa application processes, offering our customers a stress-free and reliable experience. Our expert team works meticulously to ensure positive results for your applications with their mastery of current procedures and detailed approach.',
      bullets: [
        'High Success Rate',
        'Personalized Consultancy',
        '24/7 Support',
        'Transparent Process Management'
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in Touch',
      info_title: 'Contact Information',
      address_label: 'Address',
      address_val: 'Istanbul, Turkey',
      phone_label: 'Phone',
      email_label: 'Email',
      form: {
        name: 'Full Name',
        name_ph: 'Your Full Name',
        email: 'Email',
        email_ph: 'example@email.com',
        message: 'Message',
        message_ph: 'How can we help you?',
        submit: 'SEND'
      }
    },
    footer: {
      rights: '© 2024 All rights reserved.'
    }
  }
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentBgIndex, setCurrentBgIndex] = useState(0);
  const [lang, setLang] = useState('tr');

  const t = translations[lang];

  const backgroundImages = [parisImg, usaImg, ukImg, canadaImg];
  const serviceImages = [parisImg, usaImg, ukImg, canadaImg, studentImg, businessImg];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBgIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navLinks = [
    { name: t.nav.home, href: '#home' },
    { name: t.nav.services, href: '#services' },
    { name: t.nav.about, href: '#about' },
    { name: t.nav.contact, href: '#contact' },
  ];

  return (
    <div className="font-sans antialiased text-brand-white bg-brand-navy selection:bg-brand-gold selection:text-brand-navy scroll-smooth">
      {/* Navbar */}
      <nav className="fixed w-full z-50 bg-brand-navy/90 backdrop-blur-sm border-b border-brand-light-navy shadow-lg transition-all duration-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo(0, 0)}>
              {/* Using text logo for navbar to keep it clean, or could be a small version of image */}
              <span className="text-2xl font-bold tracking-widest text-brand-gold">GLOBINKEY</span>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-center space-x-8">
                {navLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    className="text-brand-white hover:text-brand-gold transition-colors duration-300 px-3 py-2 rounded-md text-sm font-medium tracking-wide uppercase"
                  >
                    {link.name}
                  </a>
                ))}

                {/* Language Switcher */}
                <div className="flex items-center border border-brand-gold rounded-lg overflow-hidden">
                  <button
                    onClick={() => setLang('tr')}
                    className={`px-3 py-1 text-xs font-bold transition-colors ${lang === 'tr' ? 'bg-brand-gold text-brand-navy' : 'text-brand-gold hover:bg-brand-gold/10'}`}
                  >
                    TR
                  </button>
                  <button
                    onClick={() => setLang('en')}
                    className={`px-3 py-1 text-xs font-bold transition-colors ${lang === 'en' ? 'bg-brand-gold text-brand-navy' : 'text-brand-gold hover:bg-brand-gold/10'}`}
                  >
                    EN
                  </button>
                </div>
              </div>
            </div>
            <div className="-mr-2 flex md:hidden items-center gap-4">
              {/* Mobile Language Switcher */}
              <div className="flex items-center border border-brand-gold rounded-lg overflow-hidden">
                <button
                  onClick={() => setLang('tr')}
                  className={`px-2 py-1 text-xs font-bold transition-colors ${lang === 'tr' ? 'bg-brand-gold text-brand-navy' : 'text-brand-gold hover:bg-brand-gold/10'}`}
                >
                  TR
                </button>
                <button
                  onClick={() => setLang('en')}
                  className={`px-2 py-1 text-xs font-bold transition-colors ${lang === 'en' ? 'bg-brand-gold text-brand-navy' : 'text-brand-gold hover:bg-brand-gold/10'}`}
                >
                  EN
                </button>
              </div>

              <button
                onClick={toggleMenu}
                type="button"
                className="bg-brand-light-navy inline-flex items-center justify-center p-2 rounded-md text-brand-gold hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isMenuOpen ? (
                  <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                ) : (
                  <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-brand-navy border-b border-brand-light-navy" id="mobile-menu">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-gray-300 hover:text-brand-gold block px-3 py-2 rounded-md text-base font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
        {/* Background Slider */}
        <div className="absolute inset-0 z-0 select-none pointer-events-none">
          {backgroundImages.map((img, index) => (
            <div
              key={index}
              className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out blur-sm ${index === currentBgIndex ? 'opacity-40' : 'opacity-0'}`}
              style={{ backgroundImage: `url(${img})` }}
            ></div>
          ))}
          <div className="absolute inset-0 bg-brand-navy/60"></div>
        </div>

        {/* Abstract Background Shapes */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none z-0">
          <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-brand-gold blur-[120px]"></div>
          <div className="absolute top-[40%] -right-[10%] w-[40%] h-[40%] rounded-full bg-blue-900 blur-[120px]"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between z-10">
          <div className="md:w-1/2 text-center md:text-left space-y-8 z-10">
            <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight text-white leading-tight">
              {t.hero.title_start} <br />
              <span className="text-brand-gold">Globinkey</span> {t.hero.title_end}
            </h1>
            <p className="mt-4 text-lg md:text-xl text-gray-400 max-w-2xl mx-auto md:mx-0">
              {t.hero.subtitle}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center md:justify-start items-center gap-4">
              <a href="tel:+905327442525" className="px-8 py-4 bg-transparent border-2 border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-navy font-bold rounded-lg transition-all duration-300 uppercase tracking-widest text-sm shadow-[0_0_20px_rgba(212,175,55,0.2)] hover:shadow-[0_0_30px_rgba(212,175,55,0.4)]">
                {t.hero.btn_contact}
              </a>
              <a href="#services" className="px-8 py-4 bg-brand-light-navy text-white font-bold rounded-lg hover:bg-brand-light-navy/70 transition-all duration-300 border border-slate-700">
                {t.hero.btn_services}
              </a>
              <a href="https://www.instagram.com/globinkey/" target="_blank" rel="noopener noreferrer" className="p-4 bg-brand-light-navy/50 text-brand-gold border border-brand-gold/30 rounded-lg hover:bg-brand-gold hover:text-brand-navy transition-all duration-300 hover:scale-110 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="fill-current"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
              </a>
            </div>
          </div>
          <div className="md:w-1/2 mt-12 md:mt-0 flex justify-center z-10">
            <div className="relative">
              <div className="absolute inset-0 bg-brand-gold blur-[60px] opacity-20 rounded-full"></div>
              <img src={logo1} alt="Globinkey Logo" className="relative w-full max-w-2xl drop-shadow-2xl animate-pulse-slow" />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-24 bg-brand-light-navy/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-brand-gold font-bold tracking-wide uppercase text-sm mb-2">{t.services.title}</h2>
            <p className="text-3xl md:text-4xl font-extrabold text-white">{t.services.subtitle}</p>
            <div className="w-24 h-1 bg-brand-gold mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service Cards */}
            {t.services.items.map((service, idx) => (
              <div key={idx} className="group relative bg-brand-light-navy rounded-2xl border border-slate-800 hover:border-brand-gold/50 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 overflow-hidden h-96 flex flex-col">
                <div className="h-48 w-full overflow-hidden">
                  <img src={serviceImages[idx]} alt={service.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                </div>
                <div className="p-8 flex-1 flex flex-col">
                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-brand-gold transition-colors">{service.title}</h3>
                  <p className="text-gray-400 group-hover:text-gray-300 clamp-3 flex-1">{service.desc}</p>
                  <div className="self-end text-brand-gold opacity-0 group-hover:opacity-100 transition-opacity mt-4">
                    →
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-brand-navy relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center gap-16">
            <div className="md:w-1/2 flex justify-center">
              <div className="relative p-8 bg-brand-light-navy/50 rounded-full border border-brand-gold/20">
                <img src={logo2} alt="Globinkey Icon" className="w-96 h-96 object-contain opacity-90" />
              </div>
            </div>
            <div className="md:w-1/2">
              <h2 className="text-brand-gold font-bold tracking-wide uppercase text-sm mb-2">{t.about.title}</h2>
              <h3 className="text-3xl md:text-4xl font-extrabold text-white mb-6">{t.about.subtitle}</h3>
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                {t.about.text}
              </p>
              <ul className="space-y-4">
                {t.about.bullets.map((item, i) => (
                  <li key={i} className="flex items-center text-gray-300">
                    <span className="w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center mr-3">
                      <span className="text-brand-gold text-xs">✓</span>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-gradient-to-b from-brand-light-navy/30 to-brand-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-brand-gold font-bold tracking-wide uppercase text-sm mb-2">{t.contact.title}</h2>
            <p className="text-3xl md:text-4xl font-extrabold text-white">{t.contact.subtitle}</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Info */}
            <div className="bg-brand-light-navy p-10 rounded-2xl border border-slate-800">
              <h3 className="text-2xl font-bold text-white mb-8">{t.contact.info_title}</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="text-brand-gold text-xl mt-1 mr-4">📍</div>
                  <div>
                    <p className="text-white font-medium">{t.contact.address_label}</p>
                    <p className="text-gray-400">{t.contact.address_val}</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="text-brand-gold text-xl mt-1 mr-4">📞</div>
                  <div>
                    <p className="text-white font-medium">{t.contact.phone_label}</p>
                    <p className="text-gray-400">+90 532 744 25 25</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="text-brand-gold text-xl mt-1 mr-4">✉️</div>
                  <div>
                    <p className="text-white font-medium">{t.contact.email_label}</p>
                    <p className="text-gray-400">info@globinkey.com</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Form */}
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-400 mb-2">{t.contact.form.name}</label>
                <input type="text" id="name" className="block w-full bg-brand-navy border border-slate-700 rounded-lg py-3 px-4 text-white focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder={t.contact.form.name_ph} />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-2">{t.contact.form.email}</label>
                <input type="email" id="email" className="block w-full bg-brand-navy border border-slate-700 rounded-lg py-3 px-4 text-white focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder={t.contact.form.email_ph} />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-400 mb-2">{t.contact.form.message}</label>
                <textarea id="message" rows="4" className="block w-full bg-brand-navy border border-slate-700 rounded-lg py-3 px-4 text-white focus:outline-none focus:border-brand-gold focus:ring-1 focus:ring-brand-gold transition-colors" placeholder={t.contact.form.message_ph}></textarea>
              </div>
              <button type="submit" className="w-full bg-brand-gold text-brand-navy font-bold py-4 rounded-lg hover:bg-white transition-colors duration-300">
                {t.contact.form.submit}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-brand-navy border-t border-slate-800 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <span className="text-xl font-bold tracking-widest text-white">GLOBINKEY</span>
            <p className="text-sm text-gray-500 mt-2">{t.footer.rights}</p>
          </div>
          <div className="mt-4 md:mt-0">
            <a href="https://www.instagram.com/codingsentra/" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-500 hover:text-brand-gold transition-colors font-medium opacity-70 hover:opacity-100">
              Designed by Sentra Coding
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
